// Pré-carrega o clipe do baú (em memória, como blob) e as artes dos presentes assim que a página abre,
// para a abertura não esperar download nenhum.
let videoUrl = null;
let loading = null;
const imgs = {};

const pickSrc = () => {
  const v = document.createElement('video');
  return v.canPlayType('video/webm; codecs="vp9"') ? '/rp/chest_open.webm?v=3' : '/rp/chest_open.mp4?v=3';
};

export const preloadRpAssets = (propIds = []) => {
  propIds.forEach((id) => { if (!imgs[id]) { const im = new Image(); im.src = `/rp/${id}.png`; imgs[id] = im; } });
  if (!loading) {
    loading = fetch(pickSrc()).then((r) => r.blob()).then((b) => { videoUrl = URL.createObjectURL(b); return videoUrl; }).catch(() => null);
  }
  return loading;
};

export const chestVideoSrc = () => videoUrl || pickSrc();
